import { useState } from "react";
import { useHistory } from "react-router-dom";
import { Box, Button, Menu, MenuItem, Typography } from "@material-ui/core";
import LogoutIcon from "@mui/icons-material/Logout";
import DashboardIcon from "@mui/icons-material/Dashboard";
import RefreshIcon from "@mui/icons-material/Refresh";

import karstenIcon from "../../../../assets/img/logos/karsten3.png";
import trussardiIcon from "../../../../assets/img/logos/trussardi.png";
import karstenDecorIcon from "../../../../assets/img/logos/karstenDecorDark.png";
import storageFnc from "lib/localStorage.js";

const BRAND_ICONS = {
  karsten: karstenIcon,
  trussardi: trussardiIcon,
  karsten_decor: karstenDecorIcon,
};

function getInitials(name) {
  if (!name || typeof name !== "string") return "?";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    const first = parts.at(0)?.[0] ?? "";
    const last = parts.at(-1)?.[0] ?? "";
    return (first + last).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
}

export default function Header({
  theme,
  selectedBrand,
  onShowIntroScreen,
  currentBrandLabel,
}) {
  const brandIcon = BRAND_ICONS[selectedBrand];
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);

  const userDetail =
    typeof window !== "undefined"
      ? JSON.parse(localStorage.getItem("userDetail") || "null")
      : null;
  const userName = userDetail?.Nome ?? "";
  const profileName =
    userDetail?.UsuarioPerfis?.[0]?.NomePerfil ?? "Representante";

  const userVisionName =
    typeof window !== "undefined" ? localStorage.getItem("userVision") : null;
  const isUserVisionActive =
    typeof window !== "undefined" &&
    Boolean(localStorage.getItem("k-user-vision")) &&
    userVisionName &&
    userVisionName !== "default";

  const isMenuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleMenuClose();
    if (window.location.href.includes("karsten-portal-b2b-test")) {
      window.location.href = process.env.PUBLIC_URL + "/index.html?auth";
    } else {
      const userFirebaseId = localStorage.getItem("userFirebaseId");
      if (userFirebaseId) {
        localStorage.removeItem("userFirebaseId");
      }
      history.push("/");
    }
    storageFnc.clear();
  };

  const handleVoltarPainel = () => {
    handleMenuClose();
    history.push("/admin");
  };

  return (
    <Box className="header-container">
      <Box className="header-content">
        <Box className="header-left">
          {onShowIntroScreen && currentBrandLabel && (
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "12px 0",
                width: "220px",
                marginRight: 11,
              }}
            >
              <img
                src={brandIcon}
                alt={selectedBrand}
                style={{ width: 150, height: "auto" }}
              />
            </Box>
          )}
          <Box className="divider" />
          <Box>
            <Typography
              className="brand-title brand-font"
              style={{ color: theme.primary }}
            >
              Catálogo de Pedidos
            </Typography>
          </Box>
        </Box>
        <Box className="header-right">
          <Button
            type="button"
            onClick={onShowIntroScreen}
            style={{
              fontSize: 10,
              fontWeight: 700,
              textTransform: "uppercase",
              color: "#9ca3af",
              border: "1px solid #e5e7eb",
              padding: "4px 8px",
              borderRadius: 4,
              marginLeft: 24,
              minWidth: "auto",
            }}
          >
            <RefreshIcon style={{ fontSize: 12, marginRight: 4 }} />
            Trocar Marca
          </Button>
          <Box
            className="user-info"
            role="button"
            tabIndex={0}
            onClick={handleMenuOpen}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleMenuOpen(e);
              }
            }}
            style={{ cursor: "pointer" }}
            aria-haspopup="true"
            aria-controls="header-user-menu"
            aria-expanded={isMenuOpen}
          >
            <Box className="user-text">
              <Typography className="user-label">{profileName}</Typography>
              <Typography className="user-name">
                {userName || "Usuário"}
              </Typography>
              {isUserVisionActive && (
                <Typography
                  style={{
                    fontSize: 10,
                    fontWeight: 600,
                    color: "#b45309",
                    marginTop: 2,
                    maxWidth: 200,
                    lineHeight: 1.2,
                  }}
                >
                  Visualizando como: {userVisionName}
                </Typography>
              )}
            </Box>
            <Box className="user-avatar">{getInitials(userName)}</Box>
          </Box>
          <Menu
            id="header-user-menu"
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            open={isMenuOpen}
            onClose={handleMenuClose}
            getContentAnchorEl={null}
          >
            <MenuItem onClick={handleVoltarPainel}>
              <DashboardIcon style={{ fontSize: 20, marginRight: 8 }} />
              Voltar para o painel
            </MenuItem>
            <MenuItem onClick={handleLogout}>
              <LogoutIcon style={{ fontSize: 20, marginRight: 8 }} />
              Logout
            </MenuItem>
          </Menu>
        </Box>
      </Box>
    </Box>
  );
}
